import { DOI } from '@edata-portal/doi';
import { useParams } from 'wouter';

import { PageNotFound } from './PageNotFound';
import { assertStr } from './utils';

const OPENALEX_API_KEY = import.meta.env.VITE_OPENALEX_API_KEY;

export function DOIPage() {
  assertStr(OPENALEX_API_KEY);

  const { prefix, suffix } = useParams();

  if (!prefix || !suffix) {
    return <PageNotFound />;
  }

  return <DOI doi={`${prefix}/${suffix}`} openAlexApiKey={OPENALEX_API_KEY} />; // eslint-disable-line react/jsx-pascal-case
}
